import React, { ButtonHTMLAttributes, MouseEventHandler } from 'react';
import useAppContext from '../../hooks/useAppContext';
import Icon from '../../components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    onClick: MouseEventHandler<HTMLButtonElement>;
    dataTestId?: string;
}

const BackButton = ({ onClick, dataTestId, ...props }: Props) => {
    const { i18next } = useAppContext();

    return (
        <IconButton
            tooltipLabel={i18next.t('Tooltip.Nav.Title.Back')}
            onClick={onClick}
            data-test-id={dataTestId}
            {...props}
        >
            <Icon iconKey="arrow_back" className="rtl:scale-x-[-1]" />
        </IconButton>
    );
};

export default BackButton;
